"use client";

// Careers benefits band — thin wrapper around the shared Embla autoplay
// horizontal carousel (Figma 11892:39129).

import {
  Community,
  Gift,
  LotOfCash,
  Laptop,
  StatUp,
  Yoga,
} from "iconoir-react";
import type { ComponentType, SVGProps } from "react";

import { ScrollDrivenHorizontalCarousel } from "@/components/blocks/scroll-driven-horizontal-carousel";
import { BenefitIcon } from "@/components/careers/benefit-icon-gradient";
import { cn } from "@/lib/utils";

export interface CareersBenefitCard {
  title: string;
  description: string;
  icon:
    | "salary"
    | "vacation"
    | "working"
    | "growth"
    | "benefits"
    | "colleagues";
}

interface CareersBenefitsCarouselProps {
  cards: CareersBenefitCard[];
  title?: string;
  className?: string;
}

const ICONS: Record<
  CareersBenefitCard["icon"],
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  salary: LotOfCash,
  vacation: Yoga,
  working: Laptop,
  growth: StatUp,
  benefits: Gift,
  colleagues: Community,
};

export function CareersBenefitsCarousel({
  cards,
  title,
  className,
}: CareersBenefitsCarouselProps) {
  return (
    <ScrollDrivenHorizontalCarousel
      title={title}
      titleVariant="display"
      className={cn(className)}
      dataTestId="careers-benefits"
      dataFigmaSection="benefits"
      cards={cards.map((card) => ({
        title: card.title,
        description: card.description,
        renderIcon: (isActive) => (
          <BenefitIcon
            icon={ICONS[card.icon]}
            isActive={isActive}
            variant={card.icon}
          />
        ),
      }))}
    />
  );
}
